import React, { useEffect, useState } from "react";
import { Container, Row, Col, Form } from "react-bootstrap";
import { DASHBOARD_DATA, GET_BOOKING_STATS_API } from "../../../services/ApiCalls";
import { checkResponse, catchAsync } from "../../../utilities/utilities";
import Loader from "../../../components/Common/Loader";
import FeatureCard from "./components/FeatureCard";
import BookingChart from "./components/BookingChart";
import { useTranslation } from "react-i18next";
import BookingPerformance from "./components/BookingPerformance";
import GuestReviews from "./components/GuestReview";
import Reservations from "./components/Reservation";

const Dashboard = () => {
  const [dashboardData, setDashboardData] = useState(null);
  const [bookingStats, setBookingStats] = useState(null);
  const [loader, setLoader] = useState(false);
  const [topTilesPeriod, setTopTilesPeriod] = useState("yesterday");
  const [filter, setFilter] = useState("all");
  const [hotelData, setHotelData] = useState();
  const [dfilter, setDfilter] = useState('today')


  const { t } = useTranslation();

  const getData = catchAsync(async () => {
    setLoader(true);
    const statResponse = await GET_BOOKING_STATS_API({filter:dfilter})



    checkResponse({ res: statResponse, setData: setBookingStats, setLoader });
  }, setLoader);

  const dd = async () => {
    const res = await DASHBOARD_DATA();
    checkResponse({ res, setData: setDashboardData });
  }
  useEffect(() => {
    getData();
    dd()
  }, []);
  useEffect(() => {
     getData();
    // dd()
  }, [dfilter]);
  const handleStatusChange=(e)=>{
    setDfilter(e.target.value)
  }

  return (
    <>
      {loader && <Loader />}
      <section className="position-relative py-2">
        <Container>
          <Row>
            <Col lg="12">
              <div className="d-flex justify-content-between">
                <h4 className="mb-0  fw-bold text-dark">
                  {t("dashboard.title")}
                </h4>
                {/* <Form.Select
                  value={topTilesPeriod}
                  onChange={(e) => setTopTilesPeriod(e.target.value)}
                  className="w-auto"
                >
                  <option value="yesterday">Yesterday</option>
                  <option value="thisWeek">This Week</option>
                  <option value="thisMonth">This Month</option>
                  <option value="lastMonth">Last Month</option>
                  <option value="all">All</option>
                </Form.Select> */}
              </div>
            </Col>

            <Col lg="12" className="my-2">
              <div style={{ minWidth: 150 }}>
                <Form.Label className="fw-semibold text-muted mb-1 d-block">
                  {t("common.status")}
                </Form.Label>
                <Form.Select
                  size="sm"
                  value={dfilter|| ""}
                   onChange={handleStatusChange}
                  className="shadow-sm"
                  style={{ height: "40px" }}
                >
                  <option value="today">Today</option>
                  <option value="thisWeek">This Week</option>
                  <option value="thisMonth">This Month</option>

                  {/* {getStatusOptions().map((status) => (
                          <option key={status} value={!type || type === "transaction"||type==="bookingHistory"||type==="upcomingBooking"||type==="coupon" ? status : status?.toLocaleLowerCase()}>
                            {status}
                          </option>
                        ))} */}
                </Form.Select>
              </div>
              <FeatureCard dashboardData={bookingStats} period={"yesterday"} />
            </Col>

            <Col md="6" className="my-2">
              <Reservations dashboardData={dashboardData} />
            </Col>

            {/* <Col md="6" className="my-2">
              <BookingChart dashboardData={dashboardData} />
            </Col> */}
            <Col md="6" className="my-2">
              <BookingPerformance dashboardData={dashboardData} />
            </Col>
            <Col md="6" className="my-2">
              <GuestReviews dashboardData={dashboardData} />
            </Col>

            {/* <Col md="12" className="my-3">
              <NewHotelList
                title={t("dashboard.newBooking", "Upcoming Booking List")}
              />
            </Col> */}
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Dashboard;
